/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { Layout, Typography } from 'antd';

import { UnitConversionMenu } from '@/components/list/unit-conversion.list';
import { useState } from 'react';
import { useQuery } from '@/hooks/query.hook';
import { UnitConversionForm } from '@/components/forms/unit-conversion.form';

const { Content, Sider } = Layout;

export default function UnitConversionManagement() {
  const { conversionKey } = useQuery();
  const [selectedMenuKey, setSelectedMenuKey] = useState<string>(conversionKey);

  const handleSelectMenuItem = (key: string) => {
    setSelectedMenuKey(key);
  };

  return (
    <div css={rootStyles}>
      <Typography.Title css={titleStyles} level={5}>
        Quản lý chuyển đổi đơn vị
      </Typography.Title>
      <Layout>
        <Sider width={255} theme='light'>
          <UnitConversionMenu onSelectMenuItem={handleSelectMenuItem} />
        </Sider>
        <Layout>
          <Content>
            <UnitConversionForm selectedKey={selectedMenuKey} />
          </Content>
        </Layout>
      </Layout>
    </div>
  );
}

const rootStyles = css`
  background: var(--gray-soft-color);
  display: flex;
  flex-direction: column;
  gap: 1.4rem;
  padding: 1.4rem 2.4rem;
  min-height: calc(100vh - var(--header-height));
`;

const titleStyles = css`
  padding: 1.4rem;
  background: var(--white-color);
  margin-bottom: 0 !important;
  border-radius: 1rem;
`;
